import styled from 'styled-components';

import {Device} from '../../../constants';

const FeatureHeroSubtitle = styled.h3`
  && {
    font-size: 2.4em;
    margin-top: 1.5em;

    @media screen and (max-width: 940px) {
      margin-top: 7em;
    }

    @media screen and ${Device.tablet} {
      font-size: 2.8em;
      margin-top: 3em;
    }

    @media screen and ${Device.mobileL} {
      font-size: 1.4em;
      margin-top: 2em;
    }
  }
`;

export default FeatureHeroSubtitle;
